import { Component } from "@angular/core";

@Component({
    selector: 'filter-time',
    templateUrl: 'filter-time.component.html'
})
export class FilterTimeComponent {

}